// GES-16 fixed order discount — pure DISPLAY helpers. No money arithmetic (R25): they only read the
// exact 2-dp TEXT the API returns (GET /api/order-discounts/:op, order-detail totals, 4xx bodies).

// "0.00" / "0" / null -> false; any non-zero digit -> true. A text test, never a numeric compare.
export const isNonZeroText = (v) => v != null && /[1-9]/.test(String(v));

// Discounts that still carry an unrecognised, unvoided remainder (the API's own `state`).
export const openDiscounts = (list) => (list || []).filter((d) => d.state === 'open' && isNonZeroText(d.remainder));

// The API refusal codes the discount surfaces translate (keys under sales:discount.err.*).
export const DISCOUNT_ERROR_CODES = [
  'DISCOUNT_EXCEEDS_ORDER', 'DISCOUNT_EXCEEDS_CAP_WITH_FEES', 'DISCOUNT_NO_COMMITTED_ORDER', 'DISCOUNT_ORDER_SETTLED',
  'DISCOUNT_RESOLVE_FIRST', 'DISCOUNT_RETURN_UNSUPPORTED', 'DISCOUNT_USE_DELIVERY_EVENTS', 'DISCOUNT_VOID_FAILED',
  'CREDIT_NOTE_NOT_AVAILABLE', 'DISCOUNT_IDEMPOTENCY_KEY_REQUIRED', 'DISCOUNT_ZERO', 'BAD_AMOUNT', 'BAD_PCT', 'BAD_DECIMAL',
];

// A 4xx/5xx body -> one user message. Known codes are translated with the API's own figures
// (max_additional, deduct_total) passed through `fmt`; anything else shows the API's text.
// A removal (reverse / cancel / delete) that COMMITTED but whose discount void failed (500, committed:true): the
// API's own message names the order and the discount ids an admin must void — show it verbatim.
export function discountErrorText(t, data, status, fmt = String) {
  const code = data && data.code;
  if (data && data.committed === true && data.error) return data.error;
  if (DISCOUNT_ERROR_CODES.includes(code)) {
    const fig = (v) => (v == null ? '—' : fmt(v));
    return t(`discount.err.${code}`, { max_additional: fig(data.max_additional), deduct_total: fig(data.deduct_total) });
  }
  return (data && data.error) || (status ? `HTTP ${status}` : '');
}
